import styled from 'styled-components';

export const UsagePricingContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: space-between;
`;

export const BundleGridDiv = styled.div`
    display: grid;
    grid-template-columns: ${({ gridTemplateColumns }) =>
        gridTemplateColumns ? gridTemplateColumns : '100%'};
    width: 100%;
`;
export const BundleImageDiv = styled.div`
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    width: 100%;
    grid-column: 1/2;
`;
export const BundleContainerDiv = styled.div`
    width: 100%;
    grid-column: ${({ gridColumChildren }) =>
        gridColumChildren ? gridColumChildren : '2/-1'};
`;

export const UsagePricingFullWidth = styled.div`
    display: flex;
    width: 100%;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'space-between'};
    align-items: ${({ alignItem }) => (alignItem ? alignItem : 'center')};
`;

export const UsagePricingDataContainer = styled.div`
    display: flex;
    height: ${({ height }) => (height ? height : 'auto')};
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    width: ${({ width }) => (width ? width : '100%')};
    margin: ${({ margin }) => (margin ? margin : '0')};
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'flex-start'};
    align-items: ${({ alignItems }) => alignItems};
    padding: ${({ padding }) => (padding ? padding : '0')};
`;

export const UsagePriceFont = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    display: inline-block;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    color: ${({ color }) => (color ? color : '#000000')};
    text-decoration: ${({ textDecoration }) =>
        textDecoration ? textDecoration : 'none'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '20px')};
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    opacity: ${({ opacity }) => (opacity ? opacity : 1)};
    cursor: ${(props) => (props.cursor ? props.cursor : 'auto')};
`;

export const Type = styled.span`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 1;
    font-size: 13px;
`;
export const ImageContainer = styled.img`
    margin: ${({ margin }) => (margin ? margin : '0')};
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : '')};
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
`;

export const BundleTagContainer = styled.div`
    background: #f2efff 0% 0% no-repeat padding-box;
    border: 0.5px solid #c0b2ff;
    border-radius: 4px;
    opacity: 1;
    width: 59px;
    height: 18px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const DiscountInner = styled.div`
    /* padding: 8% 9% 8% 0%; */
    width: 45%;
    /* -webkit-box-align: center;
   -ms-flex-align: center;
   -webkit-align-items: center;
   -webkit-box-align: center;
   -ms-flex-align: center; */
    align-items: center;
    /* display: -ms-grid; */
    display: flex;
    height: 100%;
    justify-content: flex-start;
`;
export const Discount = styled.div`
    color: #e5047e;
    font-size: 12px;
    font-family: AvenirNextWorld Demi;
    // margin-bottom: 5px;
    /* border: 1px solid #E5047E; */
    border-radius: 4px;
    opacity: 1;
    padding: 0px 1px;
`;
